import {
  applyValidationErrors,
  clearAllFieldHighlights,
  clearSingleFieldError,
  DEFAULT_KNOWN_FIELD_IDS,
  handleRequestSaveValidationError as handleRequestSaveValidationErrorHelper,
} from "@/helper/requestValidationErrors";

export const requestValidationErrorsMixin = {
  methods: {
    getRequestValidationFieldIds(options = {}) {
      return (
        options.knownFieldIds ||
        this.array ||
        this.requestValidationFieldIds ||
        DEFAULT_KNOWN_FIELD_IDS
      );
    },

    resetRequestValidationHighlights(options = {}) {
      clearAllFieldHighlights(this.getRequestValidationFieldIds(options));
      this.$store.state.arrayOfErrors = [];
    },

    applyRequestValidationErrors(errorFields, options = {}) {
      return applyValidationErrors(
        errorFields,
        this.$store,
        this.getRequestValidationFieldIds(options)
      );
    },

    clearSingleFieldValidationError(fieldId) {
      clearSingleFieldError(fieldId, this.$store);
    },

    handleRequestSaveValidationError(err, options = {}) {
      return handleRequestSaveValidationErrorHelper(err, this, {
        ...options,
        knownFieldIds: this.getRequestValidationFieldIds(options),
      });
    },
  },
};
